function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M330.667,149.333h-192c-5.888,0-10.667,4.779-10.667,10.667s4.779,10.667,10.667,10.667h192 c5.888,0,10.667-4.779,10.667-10.667S336.555,149.333,330.667,149.333z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M74.667,384c-17.643,0-32,14.357-32,32c0,17.643,14.357,32,32,32c17.643,0,32-14.357,32-32 C106.667,398.357,92.309,384,74.667,384z M74.667,426.667C68.779,426.667,64,421.888,64,416c0-5.888,4.779-10.667,10.667-10.667 S85.333,410.112,85.333,416C85.333,421.888,80.555,426.667,74.667,426.667z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M74.667,298.667c-17.643,0-32,14.357-32,32c0,17.643,14.357,32,32,32c17.643,0,32-14.357,32-32 C106.667,313.024,92.309,298.667,74.667,298.667z M74.667,341.333c-5.888,0-10.667-4.779-10.667-10.667S68.779,320,74.667,320 s10.667,4.779,10.667,10.667S80.555,341.333,74.667,341.333z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M74.667,213.333c-17.643,0-32,14.357-32,32c0,17.643,14.357,32,32,32c17.643,0,32-14.357,32-32 C106.667,227.691,92.309,213.333,74.667,213.333z M74.667,256C68.779,256,64,251.221,64,245.333s4.779-10.667,10.667-10.667 s10.667,4.779,10.667,10.667S80.555,256,74.667,256z"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M74.667,128c-17.643,0-32,14.357-32,32s14.357,32,32,32c17.643,0,32-14.357,32-32S92.309,128,74.667,128z M74.667,170.667 C68.779,170.667,64,165.888,64,160s4.779-10.667,10.667-10.667S85.333,154.112,85.333,160S80.555,170.667,74.667,170.667z"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M456.064,106.667c-14.933,0-28.971,5.824-39.531,16.384l-29.419,29.419L384,155.584V74.667c0-17.643-14.357-32-32-32 h-55.296c-4.416-12.395-16.149-21.333-30.037-21.333h-37.845C221.291,8.32,207.317,0,192,0s-29.291,8.32-36.821,21.333h-37.845 c-13.888,0-25.621,8.939-30.037,21.333H32c-17.643,0-32,14.357-32,32V480c0,17.643,14.357,32,32,32h320c17.643,0,32-14.357,32-32 V313.728l82.133-82.133c0.021-0.021,0.043-0.021,0.064-0.043c0.021-0.021,0.021-0.043,0.043-0.064l29.376-29.376 C506.197,191.552,512,177.515,512,162.56C512,131.733,486.912,106.667,456.064,106.667z M106.667,53.333 c0-5.888,4.779-10.667,10.667-10.667h44.629c4.501,0,8.533-2.859,10.048-7.104c3.029-8.512,11.072-14.229,19.989-14.229 s16.96,5.717,19.989,14.229c1.515,4.267,5.547,7.104,10.048,7.104h44.629c5.888,0,10.667,4.779,10.667,10.667V64H106.667V53.333z  M362.667,480c0,5.888-4.779,10.667-10.667,10.667H32c-5.888,0-10.667-4.779-10.667-10.667V74.667C21.333,68.779,26.112,64,32,64 h53.333v10.667c0,5.888,4.779,10.667,10.667,10.667h192c5.888,0,10.667-4.779,10.667-10.667V64H352 c5.888,0,10.667,4.779,10.667,10.667v102.251l-59.093,59.093c-1.493-0.789-3.115-1.344-4.907-1.344h-160 c-5.888,0-10.667,4.779-10.667,10.667S132.779,256,138.667,256h144.917l-64,64h-80.917c-5.888,0-10.667,4.779-10.667,10.667 s4.779,10.667,10.667,10.667h71.68l-16,64h-55.68c-5.888,0-10.667,4.779-10.667,10.667c0,5.888,4.779,10.667,10.667,10.667h64 c0.875,0,1.728-0.107,2.581-0.341l85.333-21.333c0.256-0.064,0.427-0.299,0.683-0.384c1.344-0.448,2.56-1.131,3.605-2.027 c0.192-0.171,0.491-0.192,0.683-0.384l67.115-67.136V480z M231.936,342.976c6.891,2.005,17.088,6.443,27.179,16.555 c10.112,10.112,14.571,20.331,16.576,27.2l-58.368,14.613L231.936,342.976z M293.653,373.909 c-3.477-8.789-9.259-19.264-19.477-29.461c-10.176-10.176-20.629-15.979-29.419-19.435l149.909-149.909L443.563,224 L293.653,373.909z M480.533,187.029l-21.888,21.888l-48.896-48.896l21.888-21.909c6.528-6.549,15.211-10.133,24.469-10.133 c19.051,0,34.56,15.509,34.56,34.603C490.667,171.819,487.061,180.501,480.533,187.029z"
})));

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var SvgRequirements = function SvgRequirements(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: 33,
    height: 33,
    viewBox: "0 0 512 512",
    fill: "#fff",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRequirements, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/requirements.05639fa7.svg";
export { ForwardRef as ReactComponent };